<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import utils from './assets/js/utils'
export default {
  name: 'App',
   mounted() {
    utils.adaptive()
  }
}
</script>

<style>
html,body,#app{background: #f7f7f7;  font-size: 0.65rem}
</style>



// WEBPACK FOOTER //
// src/App.vue